import React from "react";


export const CloseIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.92">
      <path fillRule="evenodd" clipRule="evenodd" d="M19 6.42417L17.6 5.02417L12 10.6242L6.4 5.02417L5
             6.42417L10.6 12.0242L5
              17.6242L6.4 19.0242L12 13.4242L17.6
               19.0242L19 17.6242L13.4 12.0242L19 6.42417Z"
                fill="#001325"
            />
    </g>
  </svg>
);
